// RPC rate limiting constants
export const RPC_DELAY_MS = 300; // Delay between RPC batches
export const MAX_RETRIES = 3;
export const INITIAL_RETRY_DELAY_MS = 1000;

/**
 * Helper to delay execution
 */
export const delay = (ms: number): Promise<void> => new Promise((resolve) => setTimeout(resolve, ms));

/**
 * Helper to check if error is rate limiting
 */
export const isRateLimitError = (error: unknown): boolean => {
  if (error instanceof Error) {
    const message = error.message.toLowerCase();
    return message.includes('rate limit') || message.includes('429') || message.includes('too many requests');
  }
  return false;
};

/**
 * Retry wrapper with exponential backoff for rate-limited requests
 */
export const withRetry = async <T>(
  fn: () => Promise<T>,
  retries = MAX_RETRIES,
  delayMs = INITIAL_RETRY_DELAY_MS
): Promise<T> => {
  try {
    return await fn();
  } catch (error) {
    if (retries > 0 && isRateLimitError(error)) {
      console.warn(`Rate limited, retrying in ${delayMs}ms... (${retries} retries left)`);
      await delay(delayMs);
      return withRetry(fn, retries - 1, delayMs * 2);
    }
    throw error;
  }
};
